// Modules
import { Link } from 'react-router';
import React from 'react';
import _ from 'lodash';

import { BILLING_ROLES } from 'constants';
import { FormCard } from 'components/content-containers/cards';
import { PageContent } from 'components/page';
import { warning } from 'modules/alerts/actions';
import Agreement from 'services/data/agreement';
import AgreementForm from 'components/models/agreement/agreement-form';
import SVG from 'components/widgets/icons/svg';
import appHistory from 'app-history';

import { useCompany } from '../../company/store/actions';


export default function AgreementAdd({ id: companyId }) {
  const { data: company } = useCompany(companyId);

  if (!company) return null;

  const onSubmit = (values) => {
    const create = _.clone(values);

    return Agreement.create(create)
      .then(agreement => {
        appHistory.push(`/admin/agreements/${agreement.id}/summary`);

        if (company.companyType === 'Contact') {
          warning({
            title: 'This is a new client, please go set billing info!',
            subtitle: <Link to={`/companies/${company.id}/edit`}>Edit company</Link>
          });
        }
      });
  };

  const initialValues = { company: company.id };
  initialValues.rates = _.map(BILLING_ROLES, role => ({ role }));

  return (
    <PageContent className="bg-medium-blue-grey">
      <div className="agreement-summary flex flex-equal-children">
        <FormCard className="agreement-form">
          <div className="form-header">
            <SVG src="svg/agreement.svg" className="agreement" />
            <h5 className="form-title">Add Agreement</h5>
          </div>
          <AgreementForm
            initialValues={initialValues}
            onSubmit={onSubmit}
          />
        </FormCard>
      </div>
    </PageContent>
  );
}


// Component
// class AgreementAdd extends React.Component {
//   onSubmit(values) {
    
//   }

//   render() {
//     const { company } = this.props;

//     const initialValues = { company: company.id };

//     initialValues.rates = _.map(BILLING_ROLES, role => ({ role }));

//     return (
//       <PageContent className="bg-medium-blue-grey">
//         <div className="agreement-summary flex flex-equal-children">
//           <FormCard className="agreement-form">
//             <div className="form-header">
//               <SVG src="svg/agreement.svg" className="agreement" />
//               <h5 className="form-title">Add Agreement</h5>
//             </div>
//             <AgreementForm
//               initialValues={initialValues}
//               onSubmit={this.onSubmit}
//             />
//           </FormCard>
//         </div>
//       </PageContent>
//     );
//   }
// }

// // Exports
// export default connect((state) => ({
//   company: state.companies.company
// }))(AgreementAdd);



// WEBPACK FOOTER //
// ./app/routes/agreement/sub-routes/agreement-add.js